import React from 'react';
import { motion } from 'framer-motion';

// Decorative Memphis-style shapes for background
export const Star = ({ className, color = "#FFD600", size = 40 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 40 40" 
    className={className}
    fill={color}
  >
    <polygon points="20,0 25,15 40,15 28,24 33,40 20,30 7,40 12,24 0,15 15,15" />
  </svg>
);

export const Zigzag = ({ className, color = "#FF2A2A", width = 80 }) => (
  <svg 
    width={width} 
    height={width * 0.25} 
    viewBox="0 0 80 20" 
    className={className}
    fill="none"
    stroke={color}
    strokeWidth="4"
  >
    <polyline points="0,10 20,0 40,10 60,0 80,10" />
  </svg>
);

export const Circle = ({ className, color = "#00E5FF", size = 30 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 30 30" 
    className={className}
  >
    <circle cx="15" cy="15" r="12" fill={color} stroke="#000" strokeWidth="3" />
  </svg>
);

export const Triangle = ({ className, color = "#FFD600", size = 40 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 40 40" 
    className={className}
  >
    <polygon points="20,5 35,35 5,35" fill={color} stroke="#000" strokeWidth="3" />
  </svg>
);

export const Squiggle = ({ className, color = "#FF2A2A", width = 60 }) => (
  <svg 
    width={width} 
    height={width * 0.5} 
    viewBox="0 0 60 30" 
    className={className}
    fill="none"
    stroke={color}
    strokeWidth="4"
    strokeLinecap="round"
  >
    <path d="M5,15 Q15,5 25,15 T45,15 T55,15" />
  </svg>
);

export const Dots = ({ className, color = "#000000", size = 50 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 50 50" 
    className={className}
    fill={color}
  >
    <circle cx="10" cy="10" r="4" />
    <circle cx="25" cy="10" r="4" />
    <circle cx="40" cy="10" r="4" />
    <circle cx="10" cy="25" r="4" />
    <circle cx="25" cy="25" r="4" />
    <circle cx="40" cy="25" r="4" />
    <circle cx="10" cy="40" r="4" />
    <circle cx="25" cy="40" r="4" />
    <circle cx="40" cy="40" r="4" />
  </svg>
);

export const Cross = ({ className, color = "#FF2A2A", size = 30 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 30 30" 
    className={className}
    fill={color}
  >
    <rect x="12" y="0" width="6" height="30" />
    <rect x="0" y="12" width="30" height="6" />
  </svg>
);

// Animated floating shapes component
export const FloatingShapes = () => {
  const shapes = [
    { Shape: Star, color: "#FFD600", x: "5%", y: "20%", delay: 0 },
    { Shape: Circle, color: "#FF2A2A", x: "90%", y: "15%", delay: 0.5 },
    { Shape: Triangle, color: "#00E5FF", x: "85%", y: "70%", delay: 1 },
    { Shape: Zigzag, color: "#FFD600", x: "10%", y: "80%", delay: 1.5 },
    { Shape: Cross, color: "#000000", x: "95%", y: "45%", delay: 2 },
    { Shape: Dots, color: "#FF2A2A", x: "3%", y: "50%", delay: 0.3 },
  ];

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {shapes.map((item, index) => (
        <motion.div
          key={index}
          className="absolute"
          style={{ left: item.x, top: item.y }}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ 
            opacity: 1, 
            scale: 1,
            y: [0, -10, 0],
            rotate: [0, 5, -5, 0]
          }}
          transition={{
            delay: item.delay,
            duration: 0.5,
            y: {
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut"
            },
            rotate: {
              duration: 4,
              repeat: Infinity,
              ease: "easeInOut"
            }
          }}
        >
          <item.Shape color={item.color} />
        </motion.div>
      ))}
    </div>
  );
};

export default FloatingShapes;
